import React, { ComponentState, useEffect, useRef, useState } from "react";
import MultiSelectDropDown from "src/control-components/multi-select-drop-down/multi-select-drop-down";
import { filterBy } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import { getSiteList, saveButtonPressed, saveExportButtonPressed, setStaffReportFilters } from "src/redux/actions";
import { Input, Switch } from "@progress/kendo-react-inputs";
import searchIcon from "src/assets/images/search.png";

import { STAFF_CREDENTIALS_REPORT } from ".";
import { RoleService } from "src/services/rolesService";
import NoteneticLinkText from "src/control-components/notenetic-link-text";
import SettingTemplateReport from "./settingTemplateReport";
import { Tooltip } from "@progress/kendo-react-tooltip";

export function renderToItem(li, itemProps) {
    const itemChildren = (
        <span>
            <input
                type="checkbox"
                name={itemProps.dataItem}
                checked={itemProps.selected}
                onChange={(e) => itemProps.onClick(itemProps.index, e)}
            />
            &nbsp;{li.props.children}
        </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
}

function StaffCredReportFilters({ selectedReport, canExport }: { selectedReport: number, canExport: boolean }) {

        const state: ComponentState = useSelector(states => {
            return states;
        });
        const { sitesList } = state['DocumentReducer'];
    const refSiteClose = useRef<any>(null);
    const refSite = useRef<any>(null);
    const refRole = useRef<any>(null);
    const refRoleClose = useRef<any>(null);
    const [openRoleFilter, setOpenRoleFilter] = useState(false);
        const [isActiveCheck, setIsActiveCheck] = useState(false);
        const [openSiteFilter, setOpenSiteFilter] = useState(false);
            const [isDataLoadStart, setDataLoadStart] = useState(false);
    
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

        useEffect(() => {
        if (!isDataLoadStart) {
            setLoading(true)
            callSiteListApiData();
            getRoles();
            setDataLoadStart(true)
        }
        if (sitesList != null) {
            setLoading(false)
            setSiteList(sitesList);
        }
    }, [isDataLoadStart, sitesList])


    const dispatch = useDispatch()
    const callSiteListApiData = async () => {
        dispatch(getSiteList({}))
    }

    const [selectedRoles, setSelectedRoles] = useState<any[]>([]);
    const [selectedSites, setSelectedSites] = useState<any[]>([]);
    const [changedSiteList, setChangeSiteList] = useState<any[]>([]);
    const [changedRoleList, setChangeRoleList] = useState<any[]>([]);

    const [siteList, setSiteList] = useState([]);
    const [filter, setFilter] = useState<any>();
    const [setting, setSetting] = useState(false);
    const [roleData, setRoleData] = useState([]);
    const [isFilterLoaded, setIsFilterLoaded] = useState(false);
    const dropDownRef = useRef<HTMLInputElement>(null);

    const handleClearSite = () => {
        setChangeSiteList([])
        setSelectedSites([])
    }

    const handleClearRole = () => {
        setChangeRoleList([])
        setSelectedRoles([])
    }

    function handleSettingTemplateView() {
        setSetting(!setting);
    }

    const handleExportClick = () => {
        dispatch(saveExportButtonPressed(true))
    }

    const getRoles = async () => {
      await RoleService.getRoles()
        .then((result: any) => {
          let list: any = result.resultData;
          setRoleData(list);
        })
        .catch((error) => {
        });
    };


        useEffect(() => {
            document.addEventListener('mousedown', handleClickListener);
            return () => {
                document.removeEventListener('mousedown', handleClickListener);
            };
        }, []);
    
        const handleClickListener = async (event: any) => {
            if (refRole.current && !refRole.current?.contains(event.target)) {
                if (event.defaultPrevented) {
                  return;
                }
                setTimeout(() => {
                  setOpenRoleFilter(false)
                }, 200);
            }
            if (refSite.current && !refSite.current?.contains(event.target)) {
                if (event.defaultPrevented) {
                  return;
                }
                setTimeout(() => {
                  setOpenSiteFilter(false)
                }, 200);
            }
        }
    
      useEffect(() => {
        handleGenerateReportClick()  
      }, [])

       useEffect(() => {
          if (isFilterLoaded) {
              handleGenerateReportClick()
          } else {
              setIsFilterLoaded(true)
          }
      }, [searchQuery, isActiveCheck, selectedRoles, selectedSites])
        

      const handleGenerateReportClick = () => {
        const reportFilterParams = {
            isActive: !isActiveCheck,
            sites: selectedSites.map((site) => site.id) || [],
            roles: selectedRoles.map((role) => role?.id) || [],
            searchQuery: searchQuery || ""
        };        
        dispatch(setStaffReportFilters(reportFilterParams))
        dispatch(saveButtonPressed(true))
      };

      
    const handleSwitch = (e) => {
        var changeVal = e.target.value;
        setIsActiveCheck(changeVal);
    };
    
      function clearAllFilter() {
        const reportFilterParams = {
            isActive: false,
            sites: [],
            roles: [],
            searchQuery: ""
        };        
        setSelectedSites([]);
        setSelectedRoles([]);
        setChangeSiteList([]);
        setChangeRoleList([]);
        setSearchQuery("");
        setIsActiveCheck(false);
        dispatch(setStaffReportFilters(reportFilterParams));
      }

        const handleFilter = (e) => {
            var search = e.target.value;
            setSearchQuery(search);
            
            
        };

    return (
    <>
        <div className="searchBoxShadowFilter mt-2 " >
                   <div className="mx-2 row align-items-center">
                    <div className="col-lg-9 col-sm-12 pl-0 blueTheme" >
                        <div className="content-search-filter  px-0 filter-drop-down">
                                                    <img src={searchIcon} alt="" style = {{top: '24px'}}className="search-icon " />
                                                    <Input
                                                        className="icon-searchinput"
                                                        placeholder="Search"
                                                        value={searchQuery}

                                                        onChange={(e) => handleFilter(e)}
                                                    />
                            <div className="major-filter mt-2 align-items-center gapresponsive">
                                <div
                                    ref={refRole}
                                    onClick={(event: any) => {
                                        if (!refRoleClose.current?.contains(event.target)) {
                                            setOpenRoleFilter(true)
                                        }
                                    }}
                                    className="service-main dropdown mb-1 email-filter border-dashed-cus position-relative staffButton "
                                >
                                    <button className="btn  btn-size-cus pl-0 position-relative" type="button">
                                        {selectedRoles?.length > 0 ? (
                                            <i
                                                ref={refRoleClose}
                                                onClick={handleClearRole}
                                                className={"fa fa-times cross-icon mr-2 "}
                                            ></i>
                                        ) : (
                                            <i
                                                className={"fa fa-plus cross-icon "}
                                            ></i>
                                        )}     Roles
                                        {selectedRoles.length !== 0 && (
                                            <span className={selectedRoles?.length > 0 ? "border-spann" : ''}>
                                                {selectedRoles?.at(0)?.roleName} {(selectedRoles?.length && selectedRoles?.length > 1) ? '(+' + (selectedRoles.length - 1) + ')' : ''}
                                            </span>
                                        )}
                                    </button>

                                    {openRoleFilter && (
                                        <div className="dropdown-service dropInputField service-dropdown reportFilter z-5">
                                            <div className="row justify-content-end">
                                                <div ref={refRoleClose} className="col-lg-4 col-md-8 col-sm-12 ">
                                                    <div className="text-end ">
                                                        <button onClick={(event: any) => {
                                                            setSelectedRoles(changedRoleList);
                                                            setOpenRoleFilter(false);
                                                        }} type="button" className="submitButon mb-0">
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 py-2 ">
                                                    <MultiSelectDropDown
                                                        data={roleData}
                                                        textField="roleName"
                                                        label="Roles"
                                                        name="roles"
                                                        value={changedRoleList}
                                                        onChange={(event) => {
                                                            setChangeRoleList(event.target.value)
                                                            setOpenRoleFilter(true)
                                                        }}
                                                        autoClose={false}
                                                        dataItemKey={"roleName"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div> 

                                        <div
                                    ref={refSite}
                                    onClick={(event: any) => {
                                        if (!refSiteClose.current?.contains(event.target)) {
                                            setOpenSiteFilter(true)
                                        }
                                    }
                                    }
                                    className="service-main dropdown mb-1 email-filter border-dashed-cus position-relative staffButton "
                                >
                                    <button className="btn  btn-size-cus pl-0 position-relative" type="button">
                                        {selectedSites?.length > 0 ? (
                                            <i
                                                ref={refSiteClose}
                                                onClick={handleClearSite}
                                                className={"fa fa-times cross-icon mr-2 "}
                                            ></i>
                                        ) : (
                                            <i
                                                className={"fa fa-plus cross-icon "}
                                            ></i>
                                        )}     Site
                                        {selectedSites.length !== 0 && (
                                            <span className={selectedSites?.length > 0 ? "border-spann" : ''}>
                                                {selectedSites?.at(0)?.name} {(selectedSites?.length && selectedSites?.length > 1) ? '(+' + (selectedSites.length - 1) + ')' : ''}
                                            </span>
                                        )}
                                    </button>

                                    {openSiteFilter && (
                                        <div className="dropdown-service dropInputField reportFilter service-dropdown z-5">
                                            <div className="row justify-content-end">
                                                <div ref={refSiteClose} className="col-lg-4 col-md-8 col-sm-12 ">
                                                    <div className="text-end ">
                                                        <button onClick={(event: any) => {
                                                            setOpenSiteFilter(false)
                                                            setSelectedSites(changedSiteList)
                                                            //   handleChangeService('service', changedServiceList)
                                                        }} type="button" className="submitButon mb-0">
                                                            Apply
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 py-2 " ref={dropDownRef}>
                                                    <div className="">
                                                        <MultiSelectDropDown
                                                            data={filterBy(siteList, filter ? filter.siteList : [])}
                                                            loading={loading}
                                                            textField="name"
                                                            label="Site"
                                                            name="site"
                                                            ref={dropDownRef}
                                                            value={changedSiteList}
                                                            onChange={(event) => {
                                                                setChangeSiteList(event.target.value)
                                                                setOpenSiteFilter(true)
                                                            }}
                                                            autoClose={false}
                                                            dataItemKey={"id"}
                                                            itemRender={renderToItem}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div> 

                                <div className="blue_theme">
                                    <Switch
                                        onChange={handleSwitch}
                                        checked={isActiveCheck}
                                        onLabel={""}
                                        offLabel={""}
                                        className="switch-on m-0"
                                    />
                                    <span className="switch-title-text mx-md-2 mt-1 text-right resposniveMX">
                                        {" "}
                                        {selectedReport === STAFF_CREDENTIALS_REPORT
                                            && (isActiveCheck ? "Show Inactive Staff" : "Show Inactive Staff")
                                        }
                                    </span>
                                </div>


                            </div>
                        </div>
                    </div>

                        <div className="col-lg-3 col-sm-12 d-flex justify-content-end align-items-center clear-add-filter gap-3 mt-5">
                                <button
                                className="submitButon f-14 d-flex align-items-center my-2"
                                onClick={handleGenerateReportClick}
                                >
                                Run Report
                                </button>
                                <p className="mb-0" onClick={clearAllFilter}>
                                Clear Filter
                                </p>
                        </div>
                    </div>
                </div>
                <div className="mb-1 my-2 row ">
                    <div className="col-md-12 d-flex justify-content-end align-items-center">
                        {canExport && <p
                            className="filter-export d-flex align-items-center my-2 mr-4 cursor-pointer"
                            onClick={handleExportClick}
                        >
                           <NoteneticLinkText text="Export" preset="blue" /> 
                        </p>
                        }
                        <div style={{ cursor: 'pointer', fontSize: '20px' }} onClick={handleSettingTemplateView}>
                            <Tooltip anchorElement="target" position="top">
                                <i className="cursor-pointer fa fa-cog" title="Adjust Columns" />
                            </Tooltip>
                        </div>
                    </div>
                </div>
                    
                    
                {setting && (
                    <SettingTemplateReport
                        onClose={handleSettingTemplateView}
                        selectedReport={selectedReport}
                    />
                )}
    </>
)
}

export default StaffCredReportFilters